module.exports = __webpack_public_path__ + "img/timing-box-en.7ef10da9.png";